import React from 'react'
import './RippleEffect.css'
import { isMobile } from "react-device-detect";
const RippleEffect= ({ children,color,to}) => {

    const [isRippling, setIsRippling] = React.useState(false);
    return (
      <div
        className="ripple-container"
        onMouseEnter={e => {
            console.log("hover enter")

            if(!isMobile){
              setIsRippling(true)
            }
            
          }}
        onMouseLeave={e=>{
            console.log("hover leave")
            if(!isMobile){
              setIsRippling(false)
            }
           
          }}
          
        onClick={e => {
            
          // setIsRippling(false)

          //  setTimeout(()=>{
          //    setIsRippling(true)
          //  },150)
          if(isMobile){
            setIsRippling(true)
          }
          if(!isMobile){
            to&&to()
          }
          if(isMobile){
            setTimeout(()=>{
              to&&to()
            },300)
          }
        }}
      >
        {isRippling ? (
          <span
            className="ripple"
            style={{
              left: 'calc( 50% - 20px )',
              top:   '50%',
              backgroundColor:color
            }}
          />
        ) : (
          ''
        )}
        <div>{children}</div>
      </div>
    );
  };

  export default RippleEffect